import { APIResponseType } from "@/shared/types";
import { Talent, User } from "@/shared/types";
import {
  createDeleteApiHook,
  createGetApiHook,
  createPatchApiHook,
  createPostApiHook,
  createPutApiHook,
} from "@/shared/api/apiHooks";
import { API_BASE_URL } from "@/config/env";
import axios from "axios";

type talentQueryParams = Record<string, any>;

const getAllTalentAPI = (queryParams: talentQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/talents?${queryString}`;
};

const postTalentProfileEndpoint = `/users/talents`;
const getTalentById = ({ id }: { id: number }) => `/talents/${id}`;
const updateTalentEndpoint = ({ id }: { id: number }) => `/users/talents/${id}`;
const updateProfileEndpoint = `/users/profile`;

export const useCreateTalentProfile = createPostApiHook<{}, {}, APIResponseType<User>>(
  postTalentProfileEndpoint,
  {
    isFormDataMethod: false,
  }
);

export const useUpdateProfile = createPutApiHook<{}, {}, APIResponseType<User>>(
  updateProfileEndpoint,
  {
    isFormDataMethod: false,
  }
);

export const useGetATalent = createGetApiHook<APIResponseType<Talent>, { id: number }>(
  getTalentById
);

export const useGetAllTalent = createGetApiHook<APIResponseType<Talent[]>, {}>(getAllTalentAPI);

export const useUpdateTalent = createPutApiHook<{}, { id: number }, APIResponseType<Talent>>(
  updateTalentEndpoint,
  {
    isFormDataMethod: false,
  }
);

export const toggleCoffeeCallAvailabilityFn = async (
  talentId: string,
  data: Record<string, any>
) => {
  try {
    const response = await axios.patch(
      API_BASE_URL + `/users/talents/toggle-coffee-call`,
      { ...data },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
        },
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteTalentProfileEndpoint = ({ id }: { id: number }) => `/talents/${id}`;
export const useDeleteTalentProfile = createDeleteApiHook<
  {},
  { id: number },
  APIResponseType<Talent>
>(deleteTalentProfileEndpoint, {
  isFormDataMethod: false,
});
